











import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import {
  IDocumentRegistrationResultRegisteredDetail,
  IDocumentFactoryRegistrationPostMessage,
  DocumentRegistrationResult,
} from "../../domain/document";
import { BackgroundView } from "../system";
import { NewDocumentsProcessor } from "./editors";
import { DocumentParameterContainableMixin, DocumentsRegisterViewMixin } from "./mixins";

@Component({
  components: {
    BackgroundView,
    NewDocumentsProcessor,
  },
})
export default class NewDocumentsRegisterView extends Mixins(DocumentsRegisterViewMixin, DocumentParameterContainableMixin) {
  @Prop()
  formatIds: number[];

  @Prop()
  chainedFormatIds: number[];

  @Prop()
  institutionNo: string;

  @Prop()
  regionalInstitutionNo: string;

  @Prop()
  hisInfoGetterParameter: string;

  $refs!: {
    processor: NewDocumentsProcessor,
  };

  get formatCount(): number {
    return this.formatIds
      ? this.formatIds.length
      : 0;
  }

  async mounted(): Promise<void> {
    try {
      await this.start("新規文書を登録します.(" + this.formatCount + "文書)");
      this.isProcessing = true;
      const result = await this.$refs.processor.processDocuments(
        this.formatIds,
        this.$configuration.behavior.document.processor.executeIntervalMilliSeconds,
        this.institutionNo,
        this.regionalInstitutionNo,
        this.hisInfoGetterParameter,
        this.orderNo,
        this.systemKey,
        this.linkKey,
        this.parameterContainer);
      if (this.formatIds.length <= result.length) { // 大きいことはないはずだが念の為.
        this.notifyRegistered(result);
        await this.finish("新規文書を登録しました.(" + result.length + "文書)");
      } else if (0 < result.length) {
        this.notifyRegistered(result);
        await this.suspend("一部の新規文書は登録できませんでした.(" + result.length + "文書成功/" + (this.formatCount - result.length) + "文書失敗)");
      } else {
        this.notifyRegistered(result);
        await this.fatal("新規文書登録できませんでした.(" + this.formatCount + "文書)");
      }
    } catch (e) {
      this.notifyRegistered(null);
      await this.fatal(e.message, e);
    }
  }

  private notifyRegistered(result: DocumentRegistrationResult[]): void {
    if (!this.shouldNotifyRegistered) { return; }
    // DocumentFactoryのrequestでURLが指定されているときに使っている
    // フォーマットを複数指定してrequestを登録してもrequestIdが分かれるため一度に処理する文書は１つ
    // DocumentRegistrationResultも単数になるが、複数にも対応しておく
    this.postMessages(
      (result && result.length > 0) ? this.createDocumentFactoryRegistrationPostMessages(result) : this.createDocumentFactoryRegistrationFailrePostMessages()
    );
  }

  private createDocumentFactoryRegistrationPostMessages(result: DocumentRegistrationResult[]): IDocumentFactoryRegistrationPostMessage[] {
    return Enumerable.from(result)
      .select(r => this.createDocumentFactoryRegistrationPostMessage(r))
      .toArray();
  }

  private createDocumentFactoryRegistrationPostMessage(result: DocumentRegistrationResult): IDocumentFactoryRegistrationPostMessage {
    const detail = result
      ? result.detail as IDocumentRegistrationResultRegisteredDetail
      : null;
    return {
      isOk: (!result || result.isRegistered),
      documentId: detail.id,
      archiveId: detail.archiveId,
    };
  }

  private createDocumentFactoryRegistrationFailrePostMessages(): IDocumentFactoryRegistrationPostMessage[] {
    return Enumerable.from(this.formatIds)
      .select(() => ({ isOk: false, documentId: null, archiveId: null }))
      .toArray();
  }
}
